<div class="dtf-accountdetails">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>

  <!--Default page to load while waiting for Redirection to Classic-->

  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate}}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

  <div class="container_dashboard">
    <h4 class="dtfbrochures__header_dark" style=" padding-left: 41px;">{{'LoginHeader.TitleStateTransfer' | translate }}
    </h4>
    <!--Accounts & Current due amount -->
    <div class="dtfbrochures__containerlong">
      <div class="row4">
        <div class="dynamicflexbox">
          <section class="section">
            <div class="section__item section__item--start">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate}}</h4>
              <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
            </div>
            <div class="section__item section__item--end">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate}}</h4>
              <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
            </div>
          </section>
        </div>
      </div>
    </div>

    <!-- accounts grid-->

    <!-- Accounts page-->
    <div *ngIf="showAccounts" class="container_dashboard && tile">
      <div class="mbfs-contact-us-page-inner" style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px; padding-right: 21px;">
        <h5>Initiate a Title State Transfer</h5>
        <h6>Select Account(s) to initiate a Title State Transfer request from table below, then click continue. Please
          note, electronic titles have to be converted to paper before DTFS can continue with the request.</h6>
        <!-- Account search -->
        <div class="accountflex">
          <h1 class="mercedes-me-login__column-headline2"> </h1>
          <mat-form-field class="example-form-field" appearance="outline">
            <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text"
              [(ngModel)]="value">
            <img matSuffix class="example-form-img"
              src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
          </mat-form-field>
        </div>

        <!--US/EN Table loading-->
        <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
          <!--Spinner on Load-->
          <div class="demo-container">
            <span>{{ 'Invoice.Loading' | translate }}</span>
            <div class="progress-bar">
              <div class="progress-bar-value"></div>
            </div>
          </div>
          <br>
        </div>
        <!-- Account table -->
        <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
          <ng-container matColumnDef="{{column.name}}"
            *ngFor="let column of initColumns; last as isLast; first as isFirst;">
            <!-- <div *ngIf="isFirst">
              <mat-checkbox (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </div> -->
            <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
              <div *ngIf="!isFrench"> {{column.display}}</div>
              <div *ngIf="isFrench"> {{column.displayFR}}</div>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div *ngIf="isFirst"> <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)">
                </mat-checkbox>
              </div>
              <span class="mobile-label">
                <div *ngIf="!isFrench"> {{column.display}} :</div>
                <div *ngIf="isFrench"> {{column.displayFR}} :</div>
              </span>
              <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                {{element[column.name] | currency:'USD':true:'1.2-2'}}
              </div>
              <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                {{element[column.name]}}
              </div>
              <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                {{element[column.name]}}
              </div>
              <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                {{element[column.name] | date:'MM/dd/yyyy'}}
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="accountDetailsRes">
            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
              [attr.colspan]="displayedColumns.length">
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
            [class.example-expanded-row]="accountDetailsRes === element"
            (click)="accountDetailsRes = accountDetailsRes === element ? null : element">
          </mat-row>
          <mat-row *matRowDef="let row; columns: ['accountDetailsRes']" class="example-detail-row">
          </mat-row>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
            <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre "{{input.value}}"
            </td>
          </tr>

        </mat-table>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
        <br>
        <button type="submit" [disabled]="!this.tableLoaded" (click)="submitForm($event)" class="mbfs-button">{{
          'LoginModal.Continue' | translate
          }}</button>
        <button type="submit" [disabled]="!this.tableLoaded" (click)="backstep1()" class="mbfs-button">{{
          'LoginModal.back' | translate
          }}</button>
      </div>
    </div>

    <!-- VIN Details page-->
    <div *ngIf="showVinDetails" class="container_dashboard && tile">
      <div class="mbfs-contact-us-page-inner" style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px;">
        <h6>Showing assests under contract: <b>{{ selectedContractNum }} </b></h6>
        <h6>Select the VIN(s) you would like to request a Title State Transfer and click on continue. Title State
          Transfers are only available for Lien Perfected vehicles. Lease accounts must be accompanied with current
          mileage.</h6>

        <!-- VIN search bar-->
        <div class="accountflex">
          <h1 class="mercedes-me-login__column-headline2"> </h1>
          <mat-form-field class="example-form-field" appearance="outline">
            <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
            <input matInput (keyup)="applyVinFilter($event)" placeholder="Account Number or Status" #input type="text"
              [(ngModel)]="value">
            <img matSuffix class="example-form-img"
              src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
          </mat-form-field>
        </div>

        <!--Spinner on Login Load-->
        <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
          <div class="demo-container">
            <span>{{ 'Invoice.Loading' | translate }}</span>
            <div class="progress-bar">
              <div class="progress-bar-value"></div>
            </div>
          </div>
          <br>
        </div>
        <!-- VIN Table -->
        <mat-table [dataSource]="vinDataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
          <ng-container matColumnDef="{{column.name}}"
            *ngFor="let column of vininitColumns; last as isLast; first as isFirst;">
            <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
              <div> {{column.display}}</div>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div *ngIf="isFirst"> <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? vinselection.toggle(element) : null" [checked]="vinselection.isSelected(element)">
                </mat-checkbox></div>
              <span class="mobile-label">
                <div> {{column.display}} :</div>
              </span>
              <div *ngIf="column.dispFormat==''">
                {{element[column.name]}}
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="vinDetailsRes">
            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
              [attr.colspan]="vindisplayedColumns.length">
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="vindisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let element; columns: vindisplayedColumns;" class="example-element-row"
            [class.example-expanded-row]="vinDetailsRes === element"
            (click)="vinDetailsRes = vinDetailsRes === element ? null : element">
          </mat-row>
          <mat-row *matRowDef="let row; columns: ['vinDetailsRes']" class="example-detail-row"></mat-row>
          <!--No data message-->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="vindisplayedColumns.length">
              No records found.
            </td>
          </tr>
        </mat-table>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
        <br> <br>
        <button (click)="continue($event)" [disabled]="!this.tableLoaded" class="mbfs-button">{{ 'LoginModal.Continue' |
          translate }}
        </button>
        <button (click)="backstep2Accounts()" [disabled]="!this.tableLoaded" class="mbfs-button">{{ 'LoginModal.back' |
          translate }}
        </button>
      </div>
    </div>
    <!-- ----------Submit request----------------->
    <div *ngIf="showVinForm" class="container_dashboard && tile">
      <div class="mbfs-contact-us-page-inner" style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px;">
        <form #form="ngForm" ngNativeValidate [formGroup]="myForm" (ngSubmit)="submitVinForm()">
          <div class="form-group">

            <h5>Submit or Save your Request</h5> <br>
            <div>

              <p> Fill out the information for the new location where the asset will be transfered to.</p>
              <div class="row">
                <div class="col-md-6">
                  <b for="name">{{ 'DocumentCenter.ContactName' | translate }}</b><br>
                  <div class="col">
                    <p for="name">{{ name | translate }}</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <b for="vin">{{ 'VIN' | translate }}*</b><br>
                  <div class="col">
                    @if(vinReadOnly=='Y'){
                    <p for="vin">{{ vinNumber }}</p>
                    }@else{
                    <mat-form-field class="w-100" appearance="outline" id="VIN">
                      <mat-select name="vinNumber" placeholder="Please select the VIN" class="form-control"
                        formControlName="vinNumber" required validateonblur value=""
                        (selectionChange)="onSelectionChange($event)" [(ngModel)]="vinNumber" multiple="multiple">
                        <mat-option *ngFor="let opt of dropDownList" [value]="opt.id">
                          {{opt.selection}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    }
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <b for="name">{{ 'DocumentCenter.EmailAddress' | translate }}</b><br>
                  <div class="col">
                    <p for="emailAddress"> {{ emailAddress }}</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <b for="fax">{{ 'DocumentCenter.DMVFaxNo' | translate }}</b><br>
                  <div class="col">
                    <input class="form-control" type="text" name="fax" id="fax" [(ngModel)]="fax" validateonblur
                      value="" autocomplete="off">
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <b for="DMVAddress">{{ 'DocumentCenter.DMVStreet' | translate }}*</b><br>
                  <div class="col">
                    <input class="form-control" type="text" name="DMVAddress" id="DMVAddress" [(ngModel)]="DMVAddress"
                      required validateonblur value="" autocomplete="off">
                  </div>
                </div>
                <div class="col-md-6">
                  <b for="DMVPhone">{{ 'DocumentCenter.DMVPhone' | translate }}*</b><br>
                  <div class="col">
                    <input class="form-control" type="text" (keypress)="numberOnly($event)" name="DMVPhone"
                      id="DMVPhone" [(ngModel)]="DMVPhone" required validateonblur value="" autocomplete="off">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <b for="DMVStateCityZip">{{ 'DocumentCenter.DMVState' | translate }}*</b><br>
                  <div class="col">
                    <input class="form-control" type="text" name="DMVStateCityZip" id="DMVStateCityZip"
                      [(ngModel)]="DMVStateCityZip" required validateonblur value="" autocomplete="off">
                  </div>
                </div>
                <div class="col-md-6">
                  <b for="nameOfDMV">{{ 'DocumentCenter.NameOfDMV' | translate }}*</b><br>
                  <div class="col">
                    <input class="form-control" type="text" name="nameOfDMV" id="nameOfDMV" [(ngModel)]="nameOfDMV"
                      required validateonblur value="" autocomplete="off">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <b for="state">New state title needs to be transferred to*</b><br>
                  <div class="col">
                    <mat-form-field lass="w-100" appearance="outline">
                      <mat-select name="state" [(ngModel)]="state" placeholder="Select State" class="form-control"
                        autocomplete="off" formControlName="state" validateonblur required>
                        <mat-option *ngFor="let request of stateLabelValues" [value]="request.value">
                          {{request.value}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">


                  <ul>
                    <div formArrayName="odometer">
                      <li *ngFor="let column of selectedVinNumber; let i = index; trackBy: trackByIndex">
                        <b for="column.vinNum">Odometer - {{ selectedVinNumber[i] }}*</b><br>
                        <div class="col" [formGroupName]="i">
                          <input class="form-control" formControlName="odometer" #myInput
                            [value]="myForm.get('odometer').value[i]?.odometer" type="number"
                            (keypress)="numberOnly($event)" required autocomplete="off">
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>

              </div>
            </div>
          </div>
          <br>
          <div *ngIf="this.showNxtAssetBtn">
            <button type="submit" (click)="nextAsset()" class="mbfs-button">Next asset</button>
            <button type="button" class="mbfs-button" (click)="backstep2Vin()">{{ 'LoginModal.back' | translate
              }}</button>
          </div>
          <div *ngIf="!this.showNxtAssetBtn">
            <button type="submit" class="mbfs-button">{{ 'LoginModal.Submit' | translate
              }}</button>
            <button type="button" class="mbfs-button" (click)="backstep2Vin()">{{ 'LoginModal.back' | translate
              }}</button>
            <button type="button" (click)="cancel($event)" class="mbfs-button">{{ 'LoginModal.Cancel' | translate
              }}</button>
          </div>

        </form>
      </div>
    </div>

  </div>
</div>